<template>
  <VCheckbox :input-value="value" :label="label" @change="change"/>
</template>

<script>
export default {
  props: [ "value", "label" ],
  methods: {
    change(value) {
      this.$emit('input', value)
    }
  },
  created(){
    this.$emit('input', this.value || false)
  }
}
</script>

<style>

</style>
